import { render, staticRenderFns } from "./PorqueNosotros.vue?vue&type=template&id=585f57c5&"
import script from "./PorqueNosotros.vue?vue&type=script&lang=js&"
export * from "./PorqueNosotros.vue?vue&type=script&lang=js&"
import style0 from "./PorqueNosotros.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports